module.exports = __webpack_public_path__ + "img/99ne.131df626.svg";